var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height"},[_c('action-tile',{attrs:{"image":"no-lot.svg","max-image-width":"400px","title":"my-inspections.no-inspections","border":false,"clickable":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }